module.exports = __webpack_public_path__ + "img/ic-dropdown-cleaning.82ac4053.svg";